import { useAemConfig } from '@as-react/common-components';
import { useEffect, useRef } from 'react';
import { emitter, EmitterEvent } from '../util/emitter';
import { buildCategoryViewPayload, getCategoryLevelsFromTree } from '../util/TrackingUtil';
/**
 * Emits a CATEGORY_VIEW tracking event once when category data becomes available.
 */
export const useCategoryViewTracking = (categoryHierarchyTree, defaultFilter) => {
    var _a;
    const { languageAnalytics } = useAemConfig();
    const hasFired = useRef(false);
    const hasData = !!((_a = categoryHierarchyTree === null || categoryHierarchyTree === void 0 ? void 0 : categoryHierarchyTree.children) === null || _a === void 0 ? void 0 : _a.length) && !!defaultFilter;
    useEffect(() => {
        if (!hasData || hasFired.current) {
            return;
        }
        hasFired.current = true;
        const categoryLevels = getCategoryLevelsFromTree(categoryHierarchyTree, defaultFilter, languageAnalytics);
        emitter.emit(EmitterEvent.CATEGORY_VIEW, buildCategoryViewPayload(categoryLevels));
    }, [hasData, categoryHierarchyTree, defaultFilter, languageAnalytics]);
};
